<template>
  <div class="right-content mx-auto my-auto">
    <div class="header pb-3 text-center">
      <p class="lead">Login to your account</p>
    </div>
    <div class="body">
      <ValidationObserver v-slot="{ passes }">
        <form
          class="form-auth-small"
          @submit.prevent="passes(loginSubmit)"
          id="login"
        >
          <!-- Email -->
          <ValidationProvider
            name="signin_email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <div
              class="form-group"
              :class="{
                errors:
                  (errors.length && !loginformdata.signin_email) || errors[0],
                success: loginformdata.signin_email && !errors[0],
                'mb-0': apiErrorCode == 'E0004-001',
              }"
            >
              <span class="float-label">
                <input
                  type="email"
                  v-model="loginformdata.signin_email"
                  class="form-control"
                  name="email1"
                  id="signin_email"
                  placeholder="Email*"
                />
                <label for="signin_email" class="control-label">Email*</label>
                <div class="line"></div>
                <i
                  class="fa fa-times"
                  v-if="
                    (errors.length && !loginformdata.signin_email) || errors[0]
                  "
                ></i>
                <i
                  class="fa fa-check"
                  v-if="loginformdata.signin_email && !errors[0]"
                ></i>
              </span>
              <span class="text-danger" v-if="errors[0]">
                Please enter a valid Email Address
              </span>
            </div>
          </ValidationProvider>
          <span
            class="text-danger mb-3 d-block"
            v-if="apiErrorCode == 'E0004-001'"
          >
            {{ apiErrorMessage }}
          </span>
          <ValidationProvider
            name="password"
            rules="required"
            v-slot="{ errors }"
          >
            <div
              class="form-group set-password"
              :class="{
                errors: errors.length && !loginformdata.passwords,
                success: loginformdata.passwords,
                'mb-0':
                  apiErrorCode == 'V0004-001' || apiErrorCode == 'E0004-002',
              }"
            >
              <span class="float-label">
                <input
                  :type="loginformdata.password_type"
                  class="form-control"
                  id="signin-password"
                  v-model="loginformdata.passwords"
                  placeholder="Password*"
                />
                <!-- <input type="password" v-model="loginformdata.passwords" class="form-control" id="signin-password" placeholder="Password*"> -->
                <label for="signin-password" class="control-label">
                  Password*
                </label>
                <div class="line"></div>
                <i
                  class="fa fa-times"
                  v-if="errors.length && !loginformdata.passwords"
                ></i>
                <i class="fa fa-check" v-if="loginformdata.passwords"></i>
                <i
                  class="fa fa-eye"
                  :class="
                    loginformdata.password_type == 'password'
                      ? 'grey'
                      : 'success'
                  "
                  aria-hidden="true"
                  @click="showPassword()"
                ></i>
              </span>
            </div>
          </ValidationProvider>
          <span
            class="text-danger mb-3 d-block"
            v-if="apiErrorCode == 'V0004-001' || apiErrorCode == 'E0004-002'"
          >
            {{ apiErrorMessage }}
          </span>
          <!-- <div class="form-group clearfix"><label class="fancy-checkbox element-left"><input type="checkbox"><span>Remember me</span></label></div> -->
          <button type="submit" class="btn btn-primary btn-lg btn-block">
            LOGIN
          </button>

          <!-- Divider -->
          <div class="text-center my-3">
            <span class="text-muted">or</span>
            <hr class="mt-2" />
          </div>

          <!-- Microsoft Sign In Button -->
          <button
            type="button"
            class="btn btn-outline-secondary btn-lg btn-block d-flex align-items-center justify-content-center"
            @click="loginWithMicrosoft"
            :disabled="isLoading"
          >
            <!-- Microsoft Logo SVG -->
            <svg width="18" height="18" viewBox="0 0 21 21" class="me-2">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="12" y="1" width="9" height="9" fill="#00a4ef" />
              <rect x="1" y="12" width="9" height="9" fill="#7fba00" />
              <rect x="12" y="12" width="9" height="9" fill="#ffb900" />
            </svg>
            <span class="ms-2">Sign in with Microsoft</span>
          </button>

          <!-- Microsoft login recovery status -->
          <div
            v-if="apiErrorCode === 'interaction_in_progress'"
            class="alert alert-info mt-2 mb-2"
            role="alert"
          >
            <i class="fa fa-spinner fa-spin"></i>
            Recovering from login error, retrying automatically...
          </div>

          <!-- Microsoft login error display -->
          <span
            class="text-danger mb-3 d-block mt-2"
            v-if="
              apiErrorCode &&
              apiErrorCode !== 'interaction_in_progress' &&
              (apiErrorCode.startsWith('MS') ||
                apiErrorCode === 'AUTHENTICATION_FAILED' ||
                apiErrorCode === 'ACCOUNT_FORBIDDEN' ||
                apiErrorCode === 'INVALID_TOKEN' ||
                apiErrorCode === 'NETWORK_ERROR')
            "
          >
            <i class="fa fa-exclamation-circle"></i>
            {{ apiErrorMessage }}
          </span>

          <div class="bottom mt-3">
            <span class="helper-text m-b-10">
              <i class="fa fa-lock"></i>
              <router-link to="/forgot-password">Forgot password?</router-link>
            </span>
          </div>
          <!-- <div class="bottom"><span class="helper-text m-b-10"><i class="fa fa-lock"></i> <router-link to="/authentication/page-forgot-password">Forgot password?</router-link></span><span>Don't have an account? <router-link to="/authentication/page-register">Register</router-link></span></div> -->
        </form>
      </ValidationObserver>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import { USER_LOGIN, ENTRA_ID_LOGIN } from "../../../store/actions.type.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "LoginV2Component",
  components: {
    ValidationObserver,
    ValidationProvider,
    "main-loader": LoaderComponent,
    // 'button-spinner':VueButtonSpinner,
  },
  mounted() {
    // Clear any previous error messages when component loads
    this.apiErrorCode = "";
    this.apiErrorMessage = "";

    // Clear any leftover MSAL state if there's no valid backend token
    // This prevents showing stale "account not set up" errors.
    // Keep the promise so login handlers can await it — otherwise this async
    // cleanup can resolve mid-login and wipe a freshly acquired session,
    // leaving the user stuck on the login page after a "successful" toast.
    this.cleanupPromise = this.clearInconsistentAuthState();
  },
  methods: {
    async clearInconsistentAuthState() {
      try {
        const authMethod = localStorage.getItem("authMethod");
        const backendToken = localStorage.getItem("jwtToken");

        // If auth method is Entra ID but no backend token exists, clear everything
        if (authMethod === "entraId" && !backendToken) {
          console.log(
            "🧹 Clearing inconsistent Entra ID auth state on login page",
          );

          // Clear localStorage items
          localStorage.removeItem("authMethod");
          localStorage.removeItem("msalAccount");
          localStorage.removeItem("userProfile");
          localStorage.removeItem("tokenExpiresAt");
          localStorage.removeItem("currentUser");

          // Clear MSAL cache
          const { default: entraIdAuth } = await import(
            "@/services/auth/entraIdAuth"
          );
          await entraIdAuth.clearAuthState();

          console.log("✅ Cleared inconsistent auth state");
        }
      } catch (error) {
        console.error("Error clearing inconsistent auth state:", error);
      }
    },
    async loginSubmit() {
      // Wait for any in-flight inconsistent-state cleanup before authenticating
      // so it can't resolve mid-login and clear the new session.
      if (this.cleanupPromise) {
        await this.cleanupPromise;
        this.cleanupPromise = null;
      }

      let loginData = {
        email: this.loginformdata.signin_email,
        password: this.loginformdata.passwords,
        usertype: "internal",
      };
      this.$store.dispatch(USER_LOGIN, loginData).then((response) => {
        if (response.status == 200) {
          this.$toast.success("Login Successful...!!", {
            position: "top-right",
          });
          localStorage.setItem("jwtToken", response.data.token);
          localStorage.setItem("userid", response.data.userid);

          // Store auth data (roles, permissions, allowedMenuItems) in Vuex
          this.$store.dispatch("authpermission/setAuthData", {
            // user: res.data.user,
            token: response.data.token,
            roles: response.data.roles || [],
            permissions: response.data.permissions || [],
            allowedMenuItems: response.data.allowedMenuItems || [],
          });

          if (localStorage.getItem("prevURL")) {
            this.$router.push({ path: localStorage.getItem("prevURL") });
          } else {
            this.$router.push({ path: "/dashboard" });
            // this.$router.push({ path: '/transaction/middleware'})
          }
        } else {
          this.$toast.error(response.data.message, { position: "top-right" });
        }
      });
    },
    async loginWithMicrosoft() {
      try {
        this.apiErrorCode = "";
        this.apiErrorMessage = "";

        // Make sure any in-flight inconsistent-state cleanup (started in
        // mounted) has finished BEFORE we sign in. Otherwise it can resolve
        // after login succeeds and wipe the new MSAL account + jwtToken,
        // which makes navigation bounce back to the login page.
        if (this.cleanupPromise) {
          await this.cleanupPromise;
          this.cleanupPromise = null;
        }

        // Try popup first, but if it fails due to popup blocker, fallback to redirect
        let response;
        let usePopup = !this.popupAttemptFailed; // Don't retry popup if it failed before

        if (usePopup) {
          console.log("🔐 Attempting Microsoft login with popup...");
          response = await this.$store.dispatch(ENTRA_ID_LOGIN, {
            usePopup: true,
          });
        } else {
          console.log("🔐 Using redirect for Microsoft login (popup failed previously)...");
          response = await this.$store.dispatch(ENTRA_ID_LOGIN, {
            usePopup: false,
          });
          // Redirect login returns immediately and redirects to Microsoft
          return;
        }

        console.log("Microsoft login response:", response);

        if (response.status === 200) {
          this.$toast.success("Microsoft login successful!", {
            position: "top-right",
          });

          // Clear popup failure flag on success
          this.popupAttemptFailed = false;

          // Load user permissions from server (similar to traditional login flow)
          // This ensures the sidebar menu appears with proper permissions
          await this.$store.dispatch("authpermission/loadAuthData");

          // Redirect to intended page or dashboard
          if (localStorage.getItem("prevURL")) {
            this.$router.push({ path: localStorage.getItem("prevURL") });
          } else {
            this.$router.push({ path: "/dashboard" });
          }
        } else if (response.status === 409) {
          // Retry exhausted - auto-redirect to Microsoft
          console.warn("⚠️ Popup retries exhausted, auto-redirecting to Microsoft...");
          this.popupAttemptFailed = true;

          this.$toast.info(
            "Popup blocked. Redirecting to Microsoft login page...",
            {
              position: "top-right",
              duration: 2000,
            }
          );

          // Auto-trigger redirect login after brief delay
          setTimeout(async () => {
            await this.$store.dispatch(ENTRA_ID_LOGIN, {
              usePopup: false,
            });
          }, 1000);
          return;
        } else {
          // Handle specific error cases
          const errorData = response.data || {};
          const errorCode = errorData.error;
          const errorMessage = errorData.message;

          // Check for popup blocker errors and automatically fallback to redirect
          if (
            errorCode === "popup_window_error" ||
            errorMessage?.toLowerCase().includes("popup") ||
            errorMessage?.toLowerCase().includes("blocked")
          ) {
            console.warn("⚠️ Popup blocked, falling back to redirect login...");
            this.popupAttemptFailed = true;

            this.$toast.info(
              "Popup blocked. Redirecting to Microsoft login page...",
              {
                position: "top-right",
                duration: 3000,
              }
            );

            // Retry with redirect method
            setTimeout(async () => {
              await this.$store.dispatch(ENTRA_ID_LOGIN, {
                usePopup: false,
              });
            }, 1000);
            return;
          }

          // Authentication failed (401) - Generic error for security (doesn't reveal if user exists)
          // Backend returns this for both "user not found" and "invalid token" to prevent user enumeration
          if (
            response.status === 401 ||
            errorCode === "AUTHENTICATION_FAILED"
          ) {
            this.$toast.error(
              "Authentication failed. Please check your credentials or contact support.",
              {
                position: "top-right",
                duration: 6000,
              }
            );
            this.apiErrorCode = "AUTHENTICATION_FAILED";
            this.apiErrorMessage =
              errorMessage ||
              "Authentication failed. Please check your credentials or contact support.";
          }
          // Account forbidden (403) - locked, suspended, or disabled
          else if (response.status === 403 || errorCode === "FORBIDDEN") {
            this.$toast.error(
              "Account access denied. Please contact your administrator.",
              {
                position: "top-right",
                duration: 6000,
              }
            );
            this.apiErrorCode = "ACCOUNT_FORBIDDEN";
            this.apiErrorMessage =
              errorMessage ||
              "Your account is locked, suspended, or disabled. Please contact your administrator for assistance.";
          }
          // Invalid token
          else if (errorCode === "INVALID_TOKEN") {
            this.$toast.error(
              "Microsoft authentication failed. Please try again.",
              {
                position: "top-right",
              }
            );
            this.apiErrorCode = "INVALID_TOKEN";
            this.apiErrorMessage =
              errorMessage ||
              "Microsoft authentication token is invalid or expired.";
          }
          // Network error
          else if (response.status === 503 || errorCode === "NETWORK_ERROR") {
            this.$toast.error(
              "Unable to connect to authentication server. Please try again.",
              {
                position: "top-right",
              }
            );
            this.apiErrorCode = "NETWORK_ERROR";
            this.apiErrorMessage =
              "Unable to connect to authentication server. Please check your connection.";
          }
          // Generic error
          else {
            this.$toast.error(errorMessage || "Microsoft login failed", {
              position: "top-right",
              duration: 5000,
            });
            this.apiErrorCode = errorCode || "MS0001";
            this.apiErrorMessage =
              errorMessage ||
              "Microsoft login failed. Please contact your administrator if the problem persists.";
          }
        }
      } catch (error) {
        console.error("Microsoft login error:", error);

        // Check if error is due to popup being blocked
        const errorString = error.toString().toLowerCase();
        if (
          errorString.includes("popup") ||
          errorString.includes("blocked") ||
          error.errorCode === "popup_window_error"
        ) {
          console.warn("⚠️ Popup blocked (caught in exception), falling back to redirect...");
          this.popupAttemptFailed = true;

          this.$toast.info(
            "Popup blocked. Redirecting to Microsoft login page...",
            {
              position: "top-right",
              duration: 3000,
            }
          );

          // Retry with redirect method
          setTimeout(async () => {
            try {
              await this.$store.dispatch(ENTRA_ID_LOGIN, {
                usePopup: false,
              });
            } catch (redirectError) {
              console.error("Redirect login also failed:", redirectError);
              this.$toast.error("Microsoft login failed. Please try again.", {
                position: "top-right",
              });
            }
          }, 1000);
          return;
        }

        this.$toast.error("Microsoft login encountered an error", {
          position: "top-right",
        });
        this.apiErrorCode = "MS0002";
        this.apiErrorMessage =
          "Microsoft login encountered an unexpected error";
      }
    },
    showPassword() {
      this.loginformdata.password_type =
        this.loginformdata.password_type === "password" ? "text" : "password";
    },
  },
  data() {
    return {
      loginformdata: {
        signin_email: "",
        passwords: "",
        password_type: "password",
      },
      // isLoading: false,
      status: "",
      apiErrorCode: "",
      apiErrorMessage: "",
      popupAttemptFailed: false, // Track if popup login failed (to use redirect instead)
      cleanupPromise: null, // In-flight inconsistent-auth-state cleanup started on mount
    };
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
